export default __webpack_public_path__ + "static/media/Faith 9781408336762.4dee3f15.jpg";